/**
 * 회기 변경 관리 API 서비스
 */
import { SeasonUpdatePayload, UserData } from '../types/seasonUpdate';
import axiosClient from '../utils/axiosClient';

/**
 * 서버에서 전체 유저 데이터 가져오기
 * @returns 전체 유저 데이터 배열
 */
export async function fetchAllUsers(): Promise<UserData[]> {
  try {
    const response = await axiosClient.get('/users');
    return response.data.data as UserData[];
  } catch (error) {
    // 보안: 에러 객체 전체(유저 개인정보 포함 가능)를 출력하지 않고 메시지만 기록
    console.error('전체 유저 데이터 조회 오류:', error instanceof Error ? error.message : '알 수 없는 오류');
    throw new Error('전체 유저 데이터를 가져오는 중 오류가 발생했습니다.');
  }
}

/**
 * 회기 변경 적용
 * @param payload 회기 변경 데이터
 * @returns 성공 여부
 */
export async function applySeasonUpdate(payload: SeasonUpdatePayload): Promise<boolean> {
  try {
    const response = await axiosClient.post('/seasons', payload, {
      headers: {
        'Content-Type': 'application/json',
      },
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
      timeout: 60000, // 60초
    });

    return response.status === 200 || response.status === 201;
  } catch (error) {
    // 보안: 에러 객체 전체(요청 본문에 유저 개인정보 포함 가능)를 출력하지 않고 메시지만 기록
    console.error('회기 변경 적용 API 오류:', error instanceof Error ? error.message : '알 수 없는 오류');
    throw new Error('회기 변경 적용 중 오류가 발생했습니다.');
  }
}
